import Typography from '@mui/material/Typography';
import styled from '@mui/material/styles/styled';
import { Button } from '@/components/ui/buttons/Button/Button';

export const Form = styled('form')`
  display: flex;
  flex-direction: column;
  gap: 1.94rem;

  input::-ms-reveal,
  input::-ms-clear {
    display: none;
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    gap: 1.25rem;
  }

  @media screen and (max-height: 1020px) {
    gap: 1.25rem;
  }
`;

export const Title = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const SignInTitle = styled(Typography)`
  @media screen and (max-height: 1020px) {
    font-size: 2.5rem;
  }
  @media screen and (max-height: 768px) {
    font-size: 2rem;
  }
`;

export const Options = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media screen and (max-height: 1020px) {
    gap: 0.5rem;
  }
`;

export const ForgotOptions = styled('div')`
  display: flex;
  justify-content: space-evenly;
`;

export const DividerText = styled(Typography)`
  margin: 0 1rem;
`;

export const AdaptiveButton = styled(Button)`
  ${({ theme }) => theme.breakpoints.down('md')} {
    height: 2.5rem;
  }
`;

export const ForgotButton = styled(Button)`
  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 100%;
    padding: 0;
  }
`;
